<template>
<div>
            <div class="breadcrumb-list">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item active">Profile</li>
                </ol>
                <div class="emp-button btn-align text-right" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
                    <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary" >Create New Employee</button>
                </div>
            </div>
            <div class="main-box two-column">
              <employee-sidebar v-bind:employeeData="employeeData"></employee-sidebar>

                <div class="emplyee-info-wrp">
                    <div class="personal-info-page">
                        <div class="employment-details">
                            <div class="info-head">
                                <h5>Employment Details</h5>
                                <span>To be completed by a manager</span>
                            </div>
                            <div class="info-card-body">
                                <div class="row">
                                    <div class="form-group col-md-4 col-sm-6">
                                        <label >Company</label>
                                        <div class="nav-selectdrop">
                                            <select id="companyChange" class="form-control text-capitalize" @click="preventSelectOpt" @change="companyChangeOpt($event,employeeData.id)" v-model="employeeData.employee_company_id">
                                                <option v-for="(company,index) of getCompanies" :key="index" :selected="company.is_selected == 1 ? 'selected' : ''" :value="company.id">
                                                  {{ company.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4 col-sm-6">
                                        <label >Job Roles</label>
                                        <div class="nav-selectdrop">
                                            <multiselect v-model="employeeJobRole" tag-placeholder="Add this as new tag" placeholder="Select employee jobe role" label="name" track-by="name" :options="jobRoles" :multiple="true" :taggable="true" :class="'multiselct-border-design'" @remove="removeRole" @select="selectRole">
                                            </multiselect>
                                        </div>
                                        <p v-if="roleValidate" :class="{textRed : roleValidate}">Job role is required</p>
                                    </div>
                                    <div class="form-group col-md-4 col-sm-6">
                                        <div class="d-flex ">
                                            <div class="btn-wrap mr-5">
                                                <label >Remote Work</label>
                                                <div class="onoff-btn">
                                                    <a href="javascript:void(0)" class="btn" v-bind:class="employeeData.remoteWork=='yes'?'btn-primary':''" @click="remoteActiveBtn('yes')" id="salary-yes">Yes</a>
                                                    <a href="javascript:void(0)" class="btn" v-bind:class="employeeData.remoteWork=='no'?'btn-primary':''" @click="remoteActiveBtn('no')" id="salary-no">No</a>
                                                </div>
                                            </div>
                                            <div class="btn-wrap ml-5">
                                                <label >Manager Access</label>
                                                <div class="onoff-btn">
                                                    <a href="javascript:void(0)" class="btn yes" v-bind:class="employeeData.managerAccess=='yes'?'btn-primary':''" @click="activeManagerAccess('yes')">Yes</a>
                                                    <a href="javascript:void(0)" class="btn no" v-bind:class="employeeData.managerAccess=='no'?'btn-primary':''" @click="activeManagerAccess('no')">No</a>
                                                </div>
                                            </div>
                                            <div class="btn-wrap ml-5">
                                                <label >Leaves Access</label>
                                                <div class="onoff-btn">
                                                    <a href="javascript:void(0)" class="btn" v-bind:class="employeeData.is_leave_access==1?'btn-primary':''" @click="giveLeaveAccess(1)">Yes</a>
                                                    <a href="javascript:void(0)" class="btn" v-bind:class="employeeData.is_leave_access==0?'btn-primary':''" @click="giveLeaveAccess(0)">No</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="form-group col-md-4 col-sm-6">
                                        <label >Type of Employment</label>
                                        <div class="nav-selectdrop">
                                            <select id="" class="form-control" v-model="employeeData.employment_type" @change="changeEmploymentType($event)">
                                                <option value="full-time" selected>Full Time</option>
                                                <option value="part-time">Part Time</option>
                                                <option value="hourly">Hourly</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4 col-sm-6">
                                        <label >Date of Employment</label>
                                        <div class="input-wrp">
                                            <date-picker class="date-picker-width" v-model="employeeData.employment_date" format="DD-MM-YYYY" type="date"></date-picker>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-2 col-sm-6">
                                        <label >Salary Disbursement Date</label>
                                        <div class="nav-selectdrop">
                                            <select id="" class="form-control" v-model="employeeData.salary_period">
                                                <option v-for="one of salary_period2" :key="one" :value="one" :selected="employeeData.salary_period==one?'selected':''"> {{ one }} </option>
                                            </select>
                                        </div>
                                    </div>
                                  <div class="form-group col-md-2 col-sm-6">
                                    <div class="btn-wrap">
                                      <label >Salary Without Attendance</label>
                                      <div class="onoff-btn">
                                        <a href="javascript:void(0)" class="btn" id="salaryWithoutAttendanceYes" v-bind:class="employeeData.salary_without_attendance==1?'btn-primary':''" @click="activeSalaryWithoutAttendance('yes')">Yes</a>
                                        <a href="javascript:void(0)" class="btn" id="salaryWithoutAttendanceNo" v-bind:class="employeeData.salary_without_attendance==0?'btn-primary':''" @click="activeSalaryWithoutAttendance('no')">No</a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-4 col-sm-6" v-show="fullTime">
                                        <label >Basic Salary(Per Month)</label>
                                        <div class="input-wrp show-pass">
                                            <input type="number"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "10"
                                                   class="form-control" v-model="employeeData.basic_salary" @keyup="calc_hrs_rate" @click="calc_hrs_rate">
                                            <span class="currency-unit">{{ currency !== null ? currency.code :'PKR'  }}</span>
                                        </div>

                                    </div>
                                    <div class="form-group col-md-4 col-sm-6" v-show="hourly">
                                        <label >Weekly Hours</label>
                                        <input type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                               maxlength = "4"  class="form-control" v-model="employeeData.weekly_hours" @keyup="calc_hrs_rate" @click="calc_hrs_rate">
                                    </div>
                                    <div class="form-group col-md-2 col-sm-3" v-show="hourly">
                                        <label >Hourly Salary</label>
                                        <div class="input-wrp">
                                            <input type="number" class="form-control" :min="0"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "10"
                                                   v-model="employeeData.hourly_rate">
                                            <span class="currency-unit">{{ currency !== null ? currency.code :'PKR' }}</span>
                                        </div>
                                    </div>
                                  <div class="form-group col-md-2 col-sm-3">
                                    <label >Tax Per Month</label>
                                    <div class="input-wrp">
                                      <input type="number" class="form-control" :min="0"
                                             maxlength = "10"
                                             v-model="employeeData.tax_amount">
                                      <span class="currency-unit">{{ currency !== null ? currency.code :'PKR' }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-3 col-sm-4">
                                        <label > Allowed Leaves</label>
                                        <div class="input-wrp">
                                          <input type="text" class="form-control pr-15"
                                                 readonly
                                                 :value="allowedLeavesVar">
                                          <p v-if="leaveValidate==='invalid'" :class="{textRed : leaveValidate === 'invalid'}">Invalid! allowed leaves</p>
                                        </div>
                                    </div>
                                  <div class="form-group col-md-1 col-sm-2">
                                    <label  ></label>
                                    <div class="input-wrp mt-10">
                                     <router-link :to="'/employee/absence/'+employeeData.uuid"><button class="btn btn-outline-primary">Add</button></router-link>
                                    </div>
                                  </div>
                                    <div class="form-group col-md-4 col-sm-6">
                                        <label >Password </label>
                                        <div class="input-wrp pswdShowHideCls">
                                            <input :type="type" class="form-control" v-model="employeeData.decrypt_password" />
                                            <i class="ico-sec ico-eye_selected em-pass" @click="pswdShowHide" ></i>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4 col-sm-6">
                                        <label >Locations </label>
                                        <div class="nav-selectdrop">
                                            <multiselect v-model="selectedLocations" tag-placeholder="Add this as new tag" placeholder="Select employee jobe role" label="title" track-by="title" :options="locations" :multiple="true" :taggable="true" :class="'multiselct-border-design'" @select="selectLocation" @remove="removeEmployeeLocation">
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4 col-sm-6" v-if="employeeData.is_terminate === 1">
                                        <label >Termination Date</label>
                                        <div class="input-wrp">
                                            <date-picker class="date-picker-width" v-model="employeeData.terminated_date" format="DD-MM-YYYY" type="date"></date-picker>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4 col-sm-6">
                                        <label >Track Location </label>
                                        <div class="input-wrp">
                                            <input type="checkbox" v-model="employeeData.track_location" />
                                        </div>
                                    </div>
                                    <div class="form-group col-md-12">
                                        <label >Note on Employee</label>
                                        <textarea class="form-control lg" rows="3" v-model="employeeData.note"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="footer-btn">
                                <button type="button" class="btn btn-outline-primary btn-sm" @click="updateEmployeeProfile($event)">save</button>
                            </div>
                        </div>
                    </div>

        </div>
        <createEmployeeModal></createEmployeeModal>
    </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import createEmployeeModal from "../Employees/createEmployeeModal";
import DatePicker from "vue2-datepicker";
import employeeSidebar from "../Employees/employeeSidebar";
import Swal from "sweetalert2";
import axios from "axios";
export default {
  name: "userProfile",
  components: {
    Multiselect,
    createEmployeeModal,
    DatePicker,
    employeeSidebar,
  },
  data() {
    return {
      employeeData        : [],
      getCompanies        : this.$store.getters.getUser.companies,
      getCompanyBenefits  : this.$store.getters.getSelectedCompany.companyBenefits,
      jobRoles            : this.$store.getters.getSelectedCompany.jobRoles,
      selectedCompany     : this.$store.getters.getSelectedCompany,
      currency            : this.$store.getters.getSelectedCompany.currency,
      employeeJobRole     : [],
      employeeJobRoleCopy : [],
      checkAttendance     : true,
      changeCompanyFlag   : false,
      remoteWork          : "",
      managerAccess       : "",
      salaryWithoutAttendance       : "",
      salary_period2      : 30,
      type                : "password",
      fname               : "",
      lname               : "",
      showNewBtn          : false,
      leaveValidate       : "",
      employeeAllownces   : "",
      fullName            : "",
      selectedOpt         : $('#companyChange option:selected'),
      jobRolesCopy        : [],
      roleValidate        : false,
      fullTime            : true,
      hourly              : true,
      salary_decryption   : true,
      randomString        : '',
      employeeLeaveEntitlements        : '',
      locations           : [],
      selectedLocations   : [],
      allowedLeavesVar        : '',
      isTracking          : false,
      user  : this.$store.getters.getUser,
      updateStatus : false,
    };
  },
  created() {
    this.getEmployeeData();
    $(".mx-input").addClass("picker-input");
  },
  mounted() {
  },
  methods: {

    allowedLeaveFun(sum_leave_balance,sum_leave_allowed){
      this.allowedLeavesVar= sum_leave_balance+' / '+sum_leave_allowed;
    },
    getLocations(){
      let params = {
        company_id: this.selectedCompany.id
      };
      this.$axios.get(this.$locations, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.locations = res.data.result;
        }
      });
    },
    salaryShowHide(){
      if(!this.salary_decryption){
        this.salary_decryption = true;
      }else{
        this.salary_decryption = false;
      }
    },
    randomStringFun(length=10) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        this.randomString = result;
    },
    giveLeaveAccess(val){
      let msg = val==1?'give':'prohibit';
      new Swal({
        title: "",
        icon: "question",
        text: "Are you sure you want to "+msg+" leave access?",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok"
      }).then((result) => {
        if (result.value) {
          this.$axios({
            method: "post",
            data: {access:val,employee_id:this.employeeData.id},
            url: this.$GiveLeaveAccess,
            headers: this.getAuthHeader(),
          }).then((res) => {this.getEmployeeData();});
      }});
    },
    changeEmploymentType (event) {
      if(event.target.value=='full-time'){
        this.fullTime=true;
        this.partTime=true;
        this.hourly=true;
      }
      if(event.target.value=='part-time'){
        this.fullTime=true;
        this.partTime=true;
        this.hourly=true;
      }
      if(event.target.value=='hourly'){
        this.fullTime=false;
        this.partTime=true;
        this.hourly=true;
      }

    },
    selectRole(tag){
      this.roleValidate = false;
    },
    removeRole(opt){
      if(this.employeeJobRole.length == 1){
        this.roleValidate = true;
      }
    },
    selectLocation(tag){
      this.$axios({
        method: "post",
        data: {tag:tag,employee_id:this.employeeData.id},
        url: this.$AssignLocationToEmployee,
        headers: this.getAuthHeader(),
      }).then((res) => {});
    },
    getEmployeeLocations(){
      this.$axios({
        method  : "get",
        params  : {
          employee_id : this.employeeData.id,
        },
        url     : this.$GetEmployeeAssignedLocations,
        headers : this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.selectedLocations = res.data.result.map(loc => loc.location);
        }
      });
    },
    removeEmployeeLocation(tag){
      this.$axios({
            method: "post",
            data: {tag:tag,employee_id:this.employeeData.id},
            url: this.$RemoveEmployeeLocation,
            headers: this.getAuthHeader(),
          }).then((res) => {
            if (res.data.status == 200) {
              this.getEmployeeLocations();
            }
          });
    },
    onlyNumber(event, fieldname) {
      var lettersReg_no = /^[0-9]+$/;
      if (fieldname === "basic") {
        var thisTag = $("#basicNumOnly");
        if (!lettersReg_no.test(this.employeeData.basic_salary)) {
          thisTag.removeClass("d-none");
          thisTag.html("Digits Only").css("color", "red").show();
        } else {
          thisTag.hide();
        }
      } else if (fieldname === "weekly") {
        var thisTag = $("#weeklyNumOnly");
        if (!lettersReg_no.test(this.employeeData.weekly_hours)) {
          thisTag.removeClass("d-none");
          thisTag.html("Digits Only").css("color", "red").show();
        } else {
          thisTag.hide();
        }
      } else if (fieldname === "hourly") {
        var thisTag = $("#hourlyNumOnly");
        if (!lettersReg_no.test(this.employeeData.hourly_rate)) {
          thisTag.removeClass("d-none");
          thisTag.html("Digits Only").css("color", "red").show();
        } else {
          thisTag.hide();
        }
      }
    },
    leavesCheckforHalf(event) {
      return 1;
      var decimal = event.target.value - Math.floor(event.target.value) !== 0;
      if (
        (decimal && event.target.value === "2.5") ||
        (decimal && event.target.value === "1.5")
      ) {
        this.employeeData.monthly_allow_leaves = event.target.value;
        this.leaveValidate = "";
        // this.checkAttendance = false;
      } else {
        if (decimal) {
          this.leaveValidate = "invalid";
          // this.checkAttendance = true;
        } else {
          this.employeeData.monthly_allow_leaves = event.target.value;
          this.leaveValidate = "";
          // this.checkAttendance = false;
        }
      }
    },
    calc_hrs_rate() {
      console.log(this.employeeData.weekly_hours)
      if (this.employeeData.weekly_hours !== "") {
        this.employeeData.monthly_hours = this.employeeData.weekly_hours * 4;
      } else {
        this.employeeData.monthly_hours = 0;
      }

      this.employeeData.hourly_rate =
        Math.round(
          this.employeeData.basic_salary / (this.employeeData.weekly_hours * 4)
        ) || 0;
      if (this.employeeData.hourly_rate === Infinity)
        this.employeeData.hourly_rate = 0;
    },
    updateEmployeeProfile(e) {
      if(this.roleValidate){
        return false;
      }
      this.employeeData.empl_role = this.employeeJobRole.map((id) => id.id);
      this.employeeData["remoteWork"] = this.remoteWork;
      this.employeeData["managerAccess"] = this.managerAccess;
      this.employeeData["salaryWithoutAttendance"] = this.salaryWithoutAttendance;
      this.employeeData["company"] = this.employeeData.employee_company_id;
      this.employeeData["fname"] = this.fname;
      this.employeeData["lname"] = this.lname;
      this.$axios({
        method: "PUT",
        data: this.employeeData,
        url: this.$EmployeeUpdate,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          if(this.checkAttendance === this.changeCompanyFlag){
            this.$router.push({name: 'employees'});
            $root.$toast.success("Employee moved to other company");
          }else{
            this.updateStatus = true;
            this.getEmployeeData();


            $root.$toast.success("Profile updated!");
          }
        }
      });
    },
    getEmployeeData() {
      this.employeeJobRole = [];
      var id = this.$route.params.id;
      this.$axios({
        method: "get",
        params: {
          user_id: id,
          company_id: this.$store.getters.getSelectedCompany.id,
        },
        url: this.$GetEmployeeProfile,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
        if(res.data.result[0].employment_type=='full-time' || res.data.result[0].employment_type=='' ){
          this.fullTime=true;
          this.hourly=true;
        }else{
          this.fullTime=false;
          this.hourly=true;
        }
          this.employeeData   = res.data.result[0];
          this.remoteWork     = this.employeeData.remoteWork;
          this.managerAccess  = this.employeeData.managerAccess;
          this.salaryWithoutAttendance  = this.employeeData.salary_without_attendance;
          this.fullName       = this.employeeData.name.substring(0, 1).toUpperCase() + this.employeeData.name.substring(1);
          let splitName       = this.employeeData.name.split(" ");
          this.fname          = splitName[0];
          this.lname          = splitName[1];
          this.showNewBtn     = this.employeeData.lastId == this.$route.params.id ? true : false;
          this.employeeData.employment_type = (res.data.result[0].employment_type)?res.data.result[0].employment_type:'full-time';
          this.employeeData.employment_date = new Date(this.employeeData.employment_date);
          this.employeeData.terminated_date = (this.employeeData.terminated_date)? new Date(this.employeeData.terminated_date):'';
          this.employeeData.employeeJobType.map((type) => this.employeeJobRole.push(type.get_job_roles));
          this.$store.commit("setEmployeeProfileId", this.employeeData);

          if (this.updateStatus) {
              let storedEmployees = JSON.parse(localStorage.getItem('companyEmployees'));
              let updatedStoredEmployees = storedEmployees.map((emp) => {
                if (emp.id == this.employeeData.id) {
                  emp = this.employeeData;
                }
                return emp;
              });
              localStorage.setItem('companyEmployees', JSON.stringify(updatedStoredEmployees));
          }
          this.updateStatus = false;
          this.getCompanyRoles();
          this.getEmployeeLocations();
          this.getLocations();
          this.getEmployeeLeaveEntitlements();
        }
      });
    },
    getEmployeeLeaveEntitlements() {
      axios.get(this.$EmployeeLeaveEntitlements+'/total-leave-balance?employee_id='+this.employeeData.id, {
        headers: this.getAuthHeader(),
      })
        .then(res => {
          if (res.data.status === 200) {
            // this.employeeData.monthly_allow_leaves = res.data.result||0;
            this.allowedLeaveFun(res.data.result.sum_leave_balance|| 0,res.data.result.sum_leave_allowed|| 0)
          }
        });
    },
    preventSelectOpt(){
      this.selectedOpt = $("#companyChange option:selected");
    },
    companyChangeOpt(){
      if(this.checkAttendance){
        this.employeeData.employee_company_id = $("#companyChange option:selected").val();
        this.jobRoles         = [];
        this.employeeJobRole  = [];
        this.jobRoles         = this.getCompanies.filter((val) => val.id == this.employeeData.employee_company_id)[0].jobRoles;
      }else{
        this.employeeData.employee_company_id = this.selectedOpt.val();
        this.changeCompanyFlag = false;
        $root.$toast.error(this.employeeData.name+" has shifts, please complete attendance before to switch the copmany");
      }
      if(parseInt($("#companyChange option:selected").val()) === this.$store.getters.getSelectedCompany.id){
        this.changeCompanyFlag = false;
      }else{
        this.changeCompanyFlag = true;
      }
    },
    getCompanyRoles() {
      this.$axios({
        method  : "get",
        params  : {
          user_id     : this.employeeData.id,
          company_id  : this.employeeData.employee_company_id,
        },
        url     : this.$CheckEmployeeAttendance,
        headers : this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status) {
          this.checkAttendance = true;
          this.changeCompanyFlag = false;
        } else{
          this.checkAttendance  = false;
          this.changeCompanyFlag = true;
        }

      });
    },
    activeManagerAccess(activeBtn) {
      var deactivateBtn = "";

      if (activeBtn == "yes") {
        this.managerAccess = "yes";
        deactivateBtn = "no";
      } else {
        this.managerAccess = "no";
        deactivateBtn = "yes";
      }

      $("." + deactivateBtn).removeClass("btn-primary");
      $("." + activeBtn).addClass("btn-primary");
    },
    activeSalaryWithoutAttendance(activeBtn) {
      if (activeBtn == "yes") {
        this.salaryWithoutAttendance = 1;
        $("#salaryWithoutAttendanceNo" ).removeClass("btn-primary");
        $("#salaryWithoutAttendanceYes" ).addClass("btn-primary");
      } else {
        this.salaryWithoutAttendance =0;
        $("#salaryWithoutAttendanceYes" ).removeClass("btn-primary");
        $("#salaryWithoutAttendanceNo").addClass("btn-primary");
      }


    },
    remoteActiveBtn(activeBtn) {
      if (activeBtn == "yes") {
        this.remoteWork = "yes";
        $("#salary-no").removeClass("btn-primary");
        $("#salary-yes").addClass("btn-primary");
      } else {
        this.remoteWork = "no";
        $("#salary-yes").removeClass("btn-primary");
        $("#salary-no").addClass("btn-primary");
      }
    },
    pswdShowHide() {
      if (this.type == "password") {
        this.type = "text";
        $(".pswdShowHideCls").addClass("show-pass");
      } else {
        this.type = "password";
        $(".pswdShowHideCls").removeClass("show-pass");
      }
    },
  },
};
</script>

<style scoped>
.input-wrapper {
  position: relative;
}

.input-wrapper .form-control {
  padding-right: 20px;
}

.input-wrapper .ico-eye_selected {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: auto;
  right: 5px;
  cursor: pointer;
}

.textRed {
  color: red;
}

.date-picker-width {
  /* height: 100px; */
  width: 100% !important;
}

.picker-input {
  border: 0 !important;
  background: #f6f6f6 !important;
  box-shadow: none !important;
  height: 50px !important;
}
.personal-info-page .form-control{
  border-color: #343a40 !important;
}
.personal-info-page .form-group label{
  color:#6c757d;
}
.multiselct-border-design{
  border:1px solid #343a40 !important;
  color:#6c757d;
  border-color: #343a40;
  border-radius: 4px;
}
</style>
